import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { setupHead } from './utils/head';

// Metadatos y precarga del LCP, antes de montar React.
setupHead();
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-217" data-mp="269tup7tqmo9b" />);
}